'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import type { ComposerDraft } from './code-composer-draft';
import { dropQueuedComposerDraft, loadComposerDraft } from './code-composer-draft';
import { codeSessionHref } from './code-shell';
import { useForkCodeSession } from '@/data/code-sessions/mutations';

/**
 * Fork a session and open the fork, which shows its startup progress. A fork
 * before a message gets that message's prompt in its composer. Where the
 * runtime names the fork before making it, the fork opens at once under that
 * ID, and if the request fails, its view goes back to the parent. Elsewhere it
 * opens once it exists, unless the person went elsewhere meanwhile.
 */
export function useForkSession() {
  const $ = _c(3);
  const router = useRouter();
  const forkCodeSession = useForkCodeSession();
  let t0;
  if ($[0] !== forkCodeSession || $[1] !== router) {
    t0 = input => {
      const draft = input.beforeTurnId === undefined ? undefined : input.draft;
      const open = forkId => {
        if (draft !== undefined) {
          loadComposerDraft(forkId, draft);
        }
        router.push(codeSessionHref(forkId));
      };
      const {
        forkId: forkId_0,
        forked
      } = forkCodeSession({
        sessionId: input.sessionId,
        beforeTurnId: input.beforeTurnId
      });
      if (forkId_0 === null) {
        const from = window.location.pathname;
        forked.then(t1 => {
          const {
            session
          } = t1;
          if (window.location.pathname === from) {
            open(session.id);
          }
        }, _temp);
        return;
      }
      const forkHref = codeSessionHref(forkId_0);
      forked.catch(() => {
        dropQueuedComposerDraft(forkId_0);
        if (window.location.pathname === forkHref) {
          router.replace(codeSessionHref(input.sessionId));
        }
      });
      open(forkId_0);
    };
    $[0] = forkCodeSession;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp() {}